import { useEffect } from 'react'

import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection'
import { mergeRegister } from '@lexical/utils'
import { useMemoizedFn } from 'ahooks'
import {
  $getNodeByKey,
  $getSelection,
  $isNodeSelection,
  CLICK_COMMAND,
  COMMAND_PRIORITY_EDITOR,
  KEY_BACKSPACE_COMMAND,
  KEY_DELETE_COMMAND
} from 'lexical'

import { useEditor } from '../useEditor'

import { UseSelectAndRemoveProps } from './interface'

export const useSelectAndRemove = ({
  containerRef,
  nodeKey,
  allowRemove
}: UseSelectAndRemoveProps) => {
  const editor = useEditor()
  const [isSelected, setSelected] = useLexicalNodeSelection(nodeKey)

  const handleSelectNode = useMemoizedFn((event: MouseEvent) => {
    if (containerRef.current?.contains(event.target as HTMLElement)) {
      if (event.shiftKey) {
        setSelected(!isSelected)
      } else {
        setSelected(true)
      }
    }
    return false
  })

  useEffect(() => {
    return editor.registerCommand<MouseEvent>(
      CLICK_COMMAND,
      handleSelectNode,
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor, handleSelectNode])

  const handleRemoveNode = useMemoizedFn((payload: KeyboardEvent) => {
    if (isSelected && $isNodeSelection($getSelection())) {
      const event: KeyboardEvent = payload
      event.preventDefault()
      const node = $getNodeByKey(nodeKey)
      if (node && allowRemove(node)) {
        node.remove()
      }
    }
    return false
  })

  // 选中/删除
  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        KEY_DELETE_COMMAND,
        handleRemoveNode,
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand(
        KEY_BACKSPACE_COMMAND,
        handleRemoveNode,
        COMMAND_PRIORITY_EDITOR
      )
    )
  }, [editor, handleRemoveNode])

  return { isSelected }
}
